import { render, staticRenderFns } from "./WrapperMngt.vue?vue&type=template&id=564097bd&scoped=true"
import script from "./WrapperMngt.vue?vue&type=script&lang=js"
export * from "./WrapperMngt.vue?vue&type=script&lang=js"
import style0 from "./WrapperMngt.vue?vue&type=style&index=0&id=564097bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564097bd",
  null
  
)

export default component.exports